import { useEffect, useState } from 'react'
import { IStepSetting } from '../../../../../../interface/steps.interface'
import styled from './MenuStep.module.scss'
import Arrow from '../../../../../../assets/Arrow.svg'
import Check from '../../../../../../assets/Check1.svg'
import { IViewStatus } from '../../../../../../interface/progress.interface'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../../module/rootStore'

interface Props {
  stepNumber: number;
  stepData: IStepSetting;
}

const MenuStep = ({
  stepData,
  stepNumber,
}: Props) => {
  const [style, setStyle] = useState<string>()

  const { stepsProgress } = useStore().ProgressStore
  const { changeCurrentStep } = useStore().StepsStore
  
  useEffect(() => {
    const status = stepsProgress[stepNumber].viewStatus
    if (status === IViewStatus.none) {
      setStyle(styled.none)
    } else if (status === IViewStatus.current) {
      setStyle(styled.current)
    } else if (status === IViewStatus.check) {
      setStyle(styled.check)
    }
  }, [stepsProgress[stepNumber].viewStatus])

  const clickHandler = () => {
    const status = stepsProgress[stepNumber].viewStatus
    if (status !== IViewStatus.none) {
      changeCurrentStep(stepNumber)
    }
  }

  return (
    <div className={style}>
      {
        (stepsProgress[stepNumber].viewStatus === IViewStatus.current) &&
        <img className={styled.arrow} src={Arrow} />
      }
      {
        stepsProgress[stepNumber].viewStatus === IViewStatus.check &&
        <img className={styled.arrow} src={Check} />
      }
      <div className={style} onClick={clickHandler}>
        {stepData.title}
      </div>
    </div>
  )
}

export default observer(MenuStep)